import { useLang } from '@/i18n';
import EcoTextTc from 'eco-design/sections/eco-text-tc';
import styles from './index.module.scss';
import { lang } from './lang';
import { useGlobal } from '@/utils/useGlobal';

export default function Comp() {
    const { useRouter, isMobile } = useGlobal();
    const { locale } = useRouter();
    const langText = lang[locale] || lang['jp'];
    const getItems = () => [
        {
            isHead: true,
            title: langText['title'],
        },
        {
            title: langText['item_1'],
            titleColor: '#696C71',
        },
        {
            title: langText['item_2'],
            titleColor: '#696C71',
        },
        {
            isHead: true,
            title: langText['item_3'],
        },
        {
            title: langText['item_4'],
            titleColor: '#696C71',
        },
        {
            title: langText['item_5'],
            titleColor: '#696C71',
        },
        {
            title: langText['item_6'],
            titleColor: '#696C71',
        },
        {
            title: langText['item_7'],
            titleColor: '#696C71',
        },
        {
            title: langText['item_8'],
            titleColor: '#696C71',
        },
    ];
    return (
        <>
            <EcoTextTc items={getItems()} className={`${styles.comp} GtmModuleData-section`} data-section-id="FooterA" />
        </>
    );
}
